import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NotifierService } from 'angular-notifier';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private updates: SwUpdate,
    private notifier: NotifierService,
  ) {
    this.checkForUpdates();
  }

  private checkForUpdates() {
    if (this.updates.isEnabled) {
      this.updates.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.notifier.notify(
            'info',
            'نسخه جدیدی از برنامه موجود است. لطفاً صفحه را بروزرسانی کنید.',
          );
          if (
            confirm(
              'نسخه جدیدی از برنامه منتشر شده. آیا می‌خواهید صفحه را بروزرسانی کنید؟',
            )
          ) {
            this.updates
              .activateUpdate()
              .then(() => document.location.reload());
          }
        }
      });
    }
  }
}
